import classNames from "classnames";
import { memo } from "react";
import { ConversationType } from "../../enums/ConversationType";

const IdentifierDot = memo(({ conversationType }: { conversationType: ConversationType }) => (
  <span
    className={classNames({
      "w-3 h-3 min-w-3 rounded-full": true,
      "bg-blue": conversationType === ConversationType.CLIENTS,
      "bg-gold": conversationType === ConversationType.LEADS,
      "bg-asureis-gray-4": conversationType === ConversationType.OTHER,
    })}
  />
));

export default IdentifierDot;
